type Props = {
  dark?: boolean;
};

export const ThreeDotsFullScreenLoader = ({ dark }: Props) => {
  return (
    <div
      className="tw-flex"
      style={{
        height: '100vh',
        position: 'fixed',
        width: '100vw',
        zIndex: 4,
        backgroundColor: 'black',
        opacity: '0.3',
      }}
    >
      <span
        className={`square-loader${dark ? '-dark' : ''}`}
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      ></span>
    </div>
  );
};
